import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import { makeStyles } from '@mui/styles';
import { useState } from '@hookstate/core';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import TextField from '@mui/material/TextField';

const useStyles = makeStyles({
    boxContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: 1,
        width: 400
    },
});

const ChangePassword = (props) => {
    // console.log("props", props);
    const classes = useStyles();
    const password = useState('');
    const confirmPassword = useState('');
    const confPasswordErr = useState('');
    const confirmPasswordErr = useState('');
    const PasswordErr = useState('');
    
    const renderDialogContent = () => {
        return (
            <Box className={classes.boxContent}>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={14}
                    color={'primary'}
                    fontWeight={400}
                    sx={{ pb: 1 }}>
                    Username: {props.data.loginID}
                </Typography>
                <TextField
                    size='small'
                    type='password'
                    id="outlined-multiline"
                    label="Password"
                    value={password.get()}
                    sx={{ pb: 1 }}
                    onChange={(event) => { password.set(event.target.value); PasswordErr.set('') }}
                    error={
                        PasswordErr.get().length > 0 ? true : false
                    }
                    helperText={
                        PasswordErr.get().length > 0
                            ? PasswordErr.get()
                            : ''
                    }
                />

                <TextField
                    size='small'
                    id="outlined-multiline"
                    sx={{ mb: 1 }}
                    type='password'
                    label="Confirm Password"
                    value={confirmPassword.get()}
                    onChange={(event) => { confirmPassword.set(event.target.value); confPasswordErr.set('') }}
                    error={
                        confPasswordErr.get().length > 0 ? true : false
                    }
                    helperText={
                        confPasswordErr.get().length > 0
                            ? confPasswordErr.get()
                            : ''
                    }
                />
                {confirmPasswordErr.get() !== "" && <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={14}
                    textAlign={'center'}
                    color={'red'}
                    fontWeight={400}>
                    {confirmPasswordErr.get()}
                </Typography>}
            </Box>
        );
    };

    const handleClick = () => {
        if (password.get().trim() === "") {
            PasswordErr.set("Please Enter Password")
            return false
        }
        if (confirmPassword.get().trim() === "") {
            confPasswordErr.set("Please Enter Confirm Password")
            return false
        }
        if (password.get().trim() !== confirmPassword.get().trim()) {
            confirmPasswordErr.set("Password and Confirm Password should be same")
            return false
        } else {
            confirmPasswordErr.set('')
            props.handleChangePasswordSubmit(password.get(), confirmPassword.get()); 
        } 
    };

    const renderDialogActions = () => (
        <ButtonContainer
            showLoading={true}
            loading={props.submitButtonLoader}
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText={'Submit'}
        />
    );

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            // fullWidth={true}
            maxWidth={'sm'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default ChangePassword;
